import { api } from './client';

export interface BanEntry {
  ip: string;
  reason: string;
  banned_at: string;
  until: string;
  failed_attempts: number;
}

export const fetchBans = (): Promise<BanEntry[]> =>
  api.get<{ bans: BanEntry[] }>('/security/bans').then((r) => r.data.bans);

export const unbanIp = (ip: string): Promise<void> =>
  api.delete(`/security/bans/${encodeURIComponent(ip)}`).then(() => undefined);

export type CheckStatus = 'pass' | 'warn' | 'fail';

export interface AuditCheckResult {
  id: string;
  category: string;
  title: string;
  status: CheckStatus;
  detail: string;
}

export const fetchSecurityAudit = (): Promise<AuditCheckResult[]> =>
  api.get<AuditCheckResult[]>('/security/audit').then((r) => r.data);
